"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var useStyles = function useStyles(props) {
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccAudiencePickerGroupNameStyle = (0, _react.useMemo)(function () {
    var ccAudiencePickerGroupName = (0, _css.css)({
      paddingTop: pxToRem(16)
    });
    return {
      ccAudiencePickerGroupName: ccAudiencePickerGroupName
    };
  }, [pxToRem]);
  return {
    'cc-AudiencePicker__group-name': ccAudiencePickerGroupNameStyle.ccAudiencePickerGroupName
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;